import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {Actions} from '@ngrx/effects';
import * as fromRoot from '../../../../state/app.state';
import {CommonService} from "../../../shared/services/common.service";
import {Router} from "@angular/router";
import {ParticipantGroupsListService} from "./participant-groups-list.service";


@Injectable()
export class ParticipantGroupsListEffects {

  constructor(
    private store: Store<fromRoot.State>,
    private participantGroupsListService: ParticipantGroupsListService,
    private actions: Actions,
    private commonService: CommonService,
    private router: Router
  ) {
  }
}
